// src/utils/CarrinhoVariacaoUtils.js
import { criarEscolhasVariacao, obterErrosVariacoes, valorAdicionalVariacoes } from './VariacaoUtils';
export const aplicarEscolhasCarrinho = (item, produto, pedidoItemVariacoes) => {
  const diferenca = (valorAdicionalVariacoes(pedidoItemVariacoes) - valorAdicionalVariacoes(item.pedidoItemVariacoes)) * Number(item.qtde || 0);
  return { ...item, produtoVariacoes:produto.produtoVariacoes || [], pedidoItemVariacoes, variacao:null,
    valorAdicional:Number(item.valorAdicional || 0)+diferenca, valorTotal:Number(item.valorTotal || 0)+diferenca };
};
export const atualizarCarrinhoVariacoes = async (cart, fetchData) => {
  const ids = [...new Set(cart.map(item => item.id))];
  const produtos = new Map(await Promise.all(ids.map(async id => [id, await fetchData('/ProdutoDelivery/ProdutosById', { id })])));
  return cart.map(item => {
    const produto = produtos.get(item.id);
    if (!produto) throw new Error('Produto não encontrado: ' + item.descricao);
    return aplicarEscolhasCarrinho(item, produto, criarEscolhasVariacao(produto, item.pedidoItemVariacoes, item.variacao, false));
  });
};
export const validarVariacoesCarrinho = cart => {
  const pendentes = cart.filter(item => Object.keys(obterErrosVariacoes(item, item.pedidoItemVariacoes)).length);
  if (pendentes.length) throw new Error('Revise as variações no carrinho: ' + pendentes.map(item => item.descricao).join(', ') + '.');
};
